import { deepEqual } from "fast-equals";

import { zeroWidthSpaceCharRegex } from "@/helpers/textEditor";

export const clearDynamicValues = (value: string) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = value;
  const text = tempDiv.innerText || tempDiv.textContent;
  return text?.replace(zeroWidthSpaceCharRegex, "") || "";
};

export const areValuesEqual = (value1?: string, value2?: string) => {
  if (typeof value1 !== "string" || typeof value2 !== "string") {
    return deepEqual(value1, value2);
  }

  const firstClearValue = clearDynamicValues(value1);
  const secondClearValue = clearDynamicValues(value2);

  return firstClearValue === secondClearValue;
};
